import { render, staticRenderFns } from "./CreateNomination.vue?vue&type=template&id=50249431&scoped=true&"
import script from "./CreateNomination.vue?vue&type=script&lang=js&"
export * from "./CreateNomination.vue?vue&type=script&lang=js&"
import style0 from "./CreateNomination.vue?vue&type=style&index=0&id=50249431&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50249431",
  null
  
)

export default component.exports